import { AutogenModelCarriersForAssignment, AutogenRowCarriersForAssignment } from "./autogen/AutogenModelCarriersForAssignment";

export class ModelCarriersForAssignment extends AutogenModelCarriersForAssignment<RowCarriersForAssignment> {
    constructor() {
        super(RowCarriersForAssignment);
    }
}

export class RowCarriersForAssignment extends AutogenRowCarriersForAssignment {
}